import { render, staticRenderFns } from "./selectAnioComponent.vue?vue&type=template&id=5418f854&scoped=true"
import script from "./selectAnioComponent.vue?vue&type=script&lang=js"
export * from "./selectAnioComponent.vue?vue&type=script&lang=js"
import style0 from "./selectAnioComponent.vue?vue&type=style&index=0&id=5418f854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418f854",
  null
  
)

export default component.exports